import { Media } from '../presentational/media';
import { ZoneContainer } from './zone';

type TThinLeaderboardAdProps = {
  className?: string;
};

export function ThinLeaderboardAd({
  className = 'slds-text-align--center slds-m-bottom--small'
}: TThinLeaderboardAdProps) {
  return (
    <Media greaterThan="sm">
      <ZoneContainer tag="section" className={className} type="thin_leaderboard" />
    </Media>
  );
}
